import { IAvailabilitySearchQueryInstance } from '@/availability/models';
import { useOriginalSearchQuery } from '@/booking-checkout';
import { BookingRoomRequestWithRate } from '@/booking-creation/interfaces';
import {
  selectHotelConfigurationByCodeOrFail,
  useActiveBrandConfig,
} from '@/brand';

import { useCreateBookingAmendmentMutation } from './use-create-booking-amendment-mutation.hook';

export const useCreateBookingAmendment = () => {
  const {
    mutateAsync,
    isLoading,
    error,
    data: createdBooking,
  } = useCreateBookingAmendmentMutation();
  const brandConfig = useActiveBrandConfig();
  const [, setOriginalSearchQuery] = useOriginalSearchQuery();

  return {
    async createBookingAmendment({
      rooms,
      oldBookingId,
      query,
    }: {
      rooms: BookingRoomRequestWithRate[];
      query: IAvailabilitySearchQueryInstance;
      oldBookingId: string;
    }) {
      const { referenceId } = selectHotelConfigurationByCodeOrFail(
        brandConfig,
        query.hotelCode
      );

      const result = await mutateAsync({
        from: query.from,
        to: query.to,
        hotelReferenceId: referenceId,
        rateCode: rooms[0].internalRateCode,
        roomRequest: rooms,
        oldBookingId,
      });

      setOriginalSearchQuery(result.bookingId, query);

      return result;
    },
    isLoading,
    error,
    createdBooking,
  };
};
